<app-photo-gallery-list [storeCode]="this.storeCode" defaultView="mozaic" [showViews]="false" [showSizes]="false" [savingFilters]="false"/>